import { WebRTCConfigurationResponse } from "./WebRTCConfigurationResponse";

export interface AgentConfig {
  agentId: string;
  publicIP: string;
}

export interface SIPCredentials {
  username: string;
  password: string;
  websocketUrl: string;
  iceServers: string[];
}

export interface CallMeta {
  id: string;
  remoteIdentity: string;
  startTime: Date;
  status: 'connecting' | 'connected' | 'ended' | 'failed' | 'incoming';
  error?: string;
}

export interface VolumeInfo {
  input: number; // 0-100
  output: number; // 0-100
}

export interface TaarWebRTCConfig {
  debug?: boolean;
  prefix?: string;
  onCallStarted?: (callInfo: CallMeta) => void;
  onCallEnded?: () => void;
  onMute?: () => void;
  onUnmute?: () => void;
  onVolumeChange?: (volume: VolumeInfo) => void;
  onError?: (error: Error) => void;
  onDisconnect?: () => void;
  onStateChange?: (state: TaarWebRTCState) => void;
  onIncomingCall?: (callInfo: CallMeta) => void;
  onReady?: (nonce: string) => void;
}

export interface TaarWebRTCState {
  isReady: boolean;
  isRegistered: boolean;
  isCallActive: boolean;
  isMuted: boolean;
  currentCall?: CallMeta;
  volume: VolumeInfo;
  error?: Error;
}

export interface TaarWebRTCMethods {
  register: (credentials: string, audioElement?: HTMLAudioElement) => Promise<void>;
  unregister: () => Promise<void>;
  makeCall: (to: string) => Promise<void>;
  endCall: () => Promise<void>;
  mute: () => void;
  unmute: () => void;
  setVolume: (volume: Partial<VolumeInfo>) => void;
  answerCall: () => Promise<void>;
  rejectCall: () => Promise<void>;
  sendDTMF: (tones: string, duration?: number, interToneGap?: number) => Promise<void>;
} 

export interface MessageData {
  data: string;
  parameters: any;
}

export interface OptionsContentFormat {
  namespace: string;
  data: any;
}

export interface OptionsContentData {
  
}

export interface PassedMessage extends OptionsContentData {
  callId: string;
}

export interface AutoDialRequest {
  targets: Array<AutoDialTarget>
}

export interface AutoDialTarget {
  metaId: string;
  callee: string;
  caller: Array<string>;
}

export interface AutoDialResponse {
  status: AutoDialRequestStatus
}

export enum AutoDialRequestStatus {
  ACCEPTED = 'ACCEPTED', 
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  MAX_SIP_CONCURRENCY_LIMIT = 'MAX_SIP_CONCURRENCY_LIMIT',
  TARGET_VALIDATION_FAILED = 'TARGET_VALIDATION_FAILED',

  SERVER_ERROR = 'SERVER_ERROR',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NOT_ALLOWED = 'NOT_ALLOWED',

  UNKNOWN = 'UNKNOWN'
}